import React from 'react'
import { CFooter } from '@coreui/react'
const currentYear = new Date().getFullYear();

const TheFooter = () => {
  return (
    <CFooter fixed={false}
    className="border-0"
    style={{background: 'linear-gradient(90deg, rgb(255 255 255 / 72%) 0%, rgb(4 4 97 / 29%) 46%, rgb(255 255 255 / 70%) 100%)'}}
    >
      <div style={{
        fontWeight: 'bold',
        color:'black'
      }}>
        <span className="ml-1">Data Palace &copy; {currentYear} Intervalor/MIS. 🦍
        </span>
      </div>
      <div className="mfs-auto">
        <span className="mr-1"></span>
      </div>
    </CFooter>
  )
}

export default React.memo(TheFooter)